import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminLogin() {
  const { user, checked, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (checked && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen bg-[#f3f3f0] flex items-center justify-center px-6">
      <div className="w-full max-w-[420px] bg-white border border-[#e3e3e1] p-10">
        <div className="flex items-center gap-3 mb-10">
          <span className="inline-block w-4 h-4 bg-[#16181c]" />
          <span className="font-display font-bold text-lg">Cipta Andalan · CMS</span>
        </div>
        <h1 className="font-display font-semibold text-2xl text-[#16181c] tracking-[-0.02em] mb-2">
          Admin sign in
        </h1>
        <p className="text-[#5d5f64] text-sm mb-8">
          Manage site content and project portfolio.
        </p>
        <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-[#5d5f64] mb-2">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-[#e3e3e1] bg-white px-4 py-3 text-[#16181c] focus:outline-none focus:border-[#16181c]"
              data-testid="admin-login-email"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-[#5d5f64] mb-2">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-[#e3e3e1] bg-white px-4 py-3 text-[#16181c] focus:outline-none focus:border-[#16181c]"
              data-testid="admin-login-password"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <div className="text-sm text-[#16181c] bg-[#f3f3f0] border border-[#e3e3e1] px-4 py-3" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#16181c] text-white py-3 font-medium hover:bg-[#5d5f64] transition-colors disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
